/* eslint-disable import/no-unresolved */
import React, {
  useMemo, useRef, useCallback, useContext,
} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { v4 as uuidv4 } from 'uuid';
import Box from '@material-ui/core/Box';
import SearchIcon from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
// import useQlikApp from 'hooks/useQlikApp';
import useQlikSessionObject from 'hooks/useQlikSessionObject';
import Popper from '@material-ui/core/Popper';
import languagify from 'utils/languagify';
import useStyles from './styles';

import AppContext from '../../AppContext';

const Search = ({ dimension }) => {
  const classes = useStyles();

  // const qlikApp = useQlikApp();
  const { qlikApp } = useContext(AppContext);

  const { current: id } = useRef(uuidv4());

  const dataOptions = useQlikSessionObject({
    app: qlikApp,
    properties: {
      qListObjectDef: {
        qDef: {
          qFieldDefs: [dimension],
          // qFieldLabels: ['Name of media outlet for search'],
        },
        qFrequencyMode: 'V',
      },
    },
  });

  const outletOptions = useMemo(() => {
    if (!dataOptions.layout) return [];
    const sortedArray = [];
    const options = dataOptions.layout.qListObject.qDataPages[0].qMatrix.map((row) => ({
      qText: row[0].qText,
      qNum: row[0].qNum,
      qElemNumber: row[0].qElemNumber,
      qState: row[0].qState,
      qFrequency: row[0].qFrequency,
    }));

    sortedArray.push(options.filter((o) => o.qState === 'S'));
    sortedArray.push(options.filter((o) => o.qState !== 'S'));
    return sortedArray.flat();
  }, [dataOptions]);

  const selectedVal = useMemo(() => {
    if (!dataOptions.layout) return '';
    return dataOptions.layout.qListObject.qDataPages[0].qMatrix
      .filter((row) => row[0].qState === 'S')
      .map((row) => row[0]);
  }, [dataOptions.layout]);

  // Handle Open
  const handleOpen = useCallback(() => {
    dataOptions.model.beginSelections(['/qListObjectDef']);
  }, [dataOptions.model]);

  // Handle Close
  const handleClose = useCallback(() => {
    dataOptions.model.endSelections(true);
  }, [dataOptions.model]);

  const handleChange = useCallback((event, value) => {
    if (!dataOptions.model) return;
    const qValues = value.map((val) => val.qElemNumber);
    dataOptions.model.selectListObjectValues('/qListObjectDef', qValues, false);
  }, [dataOptions.model]);

  return (

    <Box className={classes.filterSearch}>
      <div className={classes.search}>
        <div className={classes.searchIcon}>
          <SearchIcon />
        </div>
        <Autocomplete
          multiple
          id={id}
          options={outletOptions}
          disableCloseOnSelect
          getOptionLabel={(option) => option.qText}
          getOptionSelected={(option, value) => option.qElemNumber === value.qElemNumber}
          renderTags={(val) => (val.length > 1 ? <span className={classes.selectedSpan}>{`${val.length} ${languagify('Selected')}`}</span> : <span className={classes.selectedSpan}>{val[0].qText}</span>)}
          onOpen={handleOpen}
          onClose={handleClose}
          onChange={handleChange}
          value={selectedVal}
          classes={{ inputRoot: classes.inputRoot }}
          PopperComponent={(props) => (<Popper {...props} className={classes.popperOptions} placement="bottom-start" />)}
          renderOption={(option) => (
            <span className={clsx({ [classes.option]: true, [classes.selected]: option.qState === 'S' })}>
              {option.qText}
            </span>
          )}
          style={{ minWidth: 250 }}
          renderInput={(params) => (
            <TextField {...params} fullWidth margin="normal" label={languagify('MY NEWSROOM *')} className={classes.inputField} />
          )}
        />

      </div>
    </Box>

  );
};

Search.propTypes = {
  dimension: PropTypes.string.isRequired,
};

export default Search;
